import { createSlice } from "@reduxjs/toolkit";
import VwHastarapordetayDTO from "src/models/PatolojiModul/VwHastarapordetayDTO";
import VwHbsHastaraporsonucDTO from "src/models/PatolojiModul/VwHbsHastaraporsonucDTO";
import RadyolojiKabulAramaKriterleri from "src/models/RadyolojiModul/RadyolojiKabulAramaKriterleri";
import VwRadyolojiIslemleriDTO from "src/models/RadyolojiModul/VwRadyolojiIslemleriDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { GridFilterModel } from "@mui/x-data-grid-premium";
import { helper } from "src/utils/helper";

interface IRadyolojiIslemState {
    searchHandler: boolean;
    aramaKriterleri: RadyolojiKabulAramaKriterleri;
    radyolojiIslemListe: Array<VwRadyolojiIslemleriDTO>;
    activeRow: VwRadyolojiIslemleriDTO;

    hastaRaporActiveRow: VwHbsHastaraporsonucDTO;
    hastaRaporDetayActiveRow: VwHastarapordetayDTO;
    labEditMode: boolean;
    radyolojGridFilterModel: GridFilterModel;

    sablonEkleOpen: boolean;
    onayOpen: boolean;
    sablonIslemlerCheck: boolean;
    ekIslemlerOpen: boolean;
    quickFilterValues: Array<any>;

    RadyolojiOnaylaOpen: boolean;
    onaySelectionIds: Array<VwRadyolojiIslemleriDTO>;
};

export const RadyolojiIslemSlice = createSlice<IRadyolojiIslemState, MapReducerPayloads<IRadyolojiIslemState, {
    setSearchHandler: boolean;
    setAramaKriterleri: RadyolojiKabulAramaKriterleri;
    setRadyolojiIslemListe: Array<VwRadyolojiIslemleriDTO>;
    setActiveRow: VwRadyolojiIslemleriDTO;

    setHastaRaporActiveRow: VwHbsHastaraporsonucDTO;
    setHastaRaporDetayActiveRow: VwHastarapordetayDTO;
    setLabEditMode: boolean;

    setSablonEkleOpen: boolean;
    setOnayOpen: boolean;
    setSablonIslemlerCheck: boolean;
    setEkIslemlerOpen: boolean;
    setQuickFilterValues: Array<any>;

    setRadyolojiOnaylaOpen: boolean;
    setonaySelectionIds: Array<VwRadyolojiIslemleriDTO>;
    setRadyolojGridFilterModel: GridFilterModel;

}>>({
    name: "radyolojiIslem",
    initialState: {
        searchHandler: false,
        aramaKriterleri: {
            ...new RadyolojiKabulAramaKriterleri(),
            baslangicTarih: helper.datetimeToday(),
            bitisTarih: helper.datetimeToday(),
            cekimDurum: 3
        },
        radyolojiIslemListe: [],
        activeRow: new VwRadyolojiIslemleriDTO(),

        hastaRaporActiveRow: new VwHbsHastaraporsonucDTO(),
        hastaRaporDetayActiveRow: new VwHastarapordetayDTO(),
        labEditMode: false,

        sablonEkleOpen: false,
        onayOpen: false,
        sablonIslemlerCheck: false,
        ekIslemlerOpen: false,
        quickFilterValues: [],

        RadyolojiOnaylaOpen: false,
        onaySelectionIds: Array<VwRadyolojiIslemleriDTO>(),
        radyolojGridFilterModel: { items: [] },

    },
    reducers: {
        setSearchHandler: (state: IRadyolojiIslemState, action) => {
            state.searchHandler = action.payload
        },
        setAramaKriterleri: (state: IRadyolojiIslemState, action) => {
            state.aramaKriterleri = action.payload
        },
        setRadyolojiIslemListe: (state: IRadyolojiIslemState, action) => {
            state.radyolojiIslemListe = action.payload
        },
        setActiveRow: (state: IRadyolojiIslemState, action) => {
            state.activeRow = action.payload
        },

        setHastaRaporActiveRow: (state, action) => {
            state.hastaRaporActiveRow = action.payload
        },
        setHastaRaporDetayActiveRow: (state, action) => {
            state.hastaRaporDetayActiveRow = action.payload
        },
        setLabEditMode: (state, action) => {
            state.labEditMode = action.payload
        },

        setSablonEkleOpen: (state, action) => {
            state.sablonEkleOpen = action.payload
        },
        setSablonIslemlerCheck: (state, action) => {
            state.sablonIslemlerCheck = action.payload
        },
        setEkIslemlerOpen: (state, action) => {
            state.ekIslemlerOpen = action.payload
        },
        setQuickFilterValues: (state, action) => {
            state.quickFilterValues = action.payload
        },
        setonaySelectionIds: (state, action) => {
            state.onaySelectionIds = action.payload
        },
        setRadyolojiOnaylaOpen: (state, action) => {
            state.RadyolojiOnaylaOpen = action.payload
        },
        setRadyolojGridFilterModel: (state, action) => {
            state.radyolojGridFilterModel = action.payload
        },
        setOnayOpen: (state, action) => {
            state.onayOpen = action.payload
        },

    }
});